import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import formatDateInLocalTimezone from '../utils/dateFormatting'

type Props = {
  last_activity_at: string,
  last_activity_by: {
    name: string,
    profile_url: string
  }
}

const LastActivityCell = () => {
  return ({ last_activity_at, last_activity_by } : Props) => {
    if (!last_activity_at) {
      return null
    }

    const { name, profile_url } = last_activity_by
    const user = { ...last_activity_by, url: profile_url }
    const date = formatDateInLocalTimezone(last_activity_at)

    return (
      <div className='overview__table-last-activity'>
        <div className='overview__table-last-activity-date'>{date + ' by '}</div>
        <UserAvatar user={user} openInNewTab style={{ width: '16px', height: '16px' }} />
        <a href={user.url} target='_blank'>{name}</a>
      </div>
    )
  }
}

export default LastActivityCell
